import { useCallback, useRef } from 'react';

// Owns a single in-flight AbortController. `next()` aborts whatever request
// was running before, mints a fresh controller, stashes it on the ref, and
// returns it — the typeahead/scan flows in Search.tsx use this to ensure
// they only ever have one outbound /search/suggest request alive at a time.
export function useAbortRef(): { next: () => AbortController } {
  const ref = useRef<AbortController | null>(null);
  const next = useCallback(() => {
    ref.current?.abort();
    const ac = new AbortController();
    ref.current = ac;
    return ac;
  }, []);
  return { next };
}
